import { BadgeArtColors } from './types.js'

/** Literal light-theme colours for server-side PNG rendering (from nope-badges THEMES.light). */
export const BADGE_ART_LIGHT_COLORS: BadgeArtColors = {
    shadow: 'rgba(38,18,66,.34)',
    slot: '#EDE8F3',
    slotInk: '#C9BED6',
    slotHi: 'rgba(255,255,255,.95)',
    slotShade: 'rgba(44,22,78,.42)',
}

export const BADGE_ART_DARK_COLORS: BadgeArtColors = {
    shadow: 'rgba(0,0,0,.62)',
    slot: '#221A2B',
    slotInk: '#4A3E58',
    slotHi: 'rgba(255,255,255,.08)',
    slotShade: 'rgba(0,0,0,.75)',
}

/** The browser resolves these from theme.scss tokens, so one SVG follows the theme. */
export const BADGE_ART_CSS_COLORS: BadgeArtColors = {
    shadow: 'var(--badge-shadow)',
    slot: 'var(--badge-slot)',
    slotInk: 'var(--badge-slot-ink)',
    slotHi: 'var(--badge-slot-hi)',
    slotShade: 'var(--badge-slot-shade)',
}

/** viewBox is -14 -12 228 236: height / width. */
export const BADGE_ASPECT = 236 / 228
